/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { DeliveryOption } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';

export interface IPickUpOptionListProps {
    pickupListOptionMenuText: string;
    pickupmodeList?: DeliveryOption[];
    onChange(deliveryCode: string): Promise<void>;
}

export interface IPickOptionListState {
    expandSiteOptions: boolean;
}

/**
 * Simple Pickup option dropdown with Button to get menu option.
 */
export class PickUpOptionList extends React.PureComponent<IPickUpOptionListProps, IPickOptionListState> {
    private readonly _pickupListOptionMenu: React.RefObject<HTMLUListElement>;

    constructor(props: IPickUpOptionListProps) {
        super(props);
        this._rendeDeliveryOptions = this._rendeDeliveryOptions.bind(this);
        this._pickupListOptionMenu = React.createRef();
        this.state = {
            expandSiteOptions: false
        };
    }

    public render(): JSX.Element {
        const { pickupListOptionMenuText, pickupmodeList } = this.props;

        return (
            <div className='ms-store-select__location-line-pickup'>
                <button className='ms-store-select__location-line-pickup-menu' onClick={this._rendeDeliveryOptions}>
                    {pickupListOptionMenuText}
                    <span className='ms-store-select__location-line-pickup-span' />
                </button>
                {this.state.expandSiteOptions ? (
                    <ul className='ms-store-select__location-line-pickup-list' role='menu' ref={this._pickupListOptionMenu}>
                        {pickupmodeList?.map((delivery: DeliveryOption) => {
                            return (
                                <li role='menu' className='ms-store-select__location-line-pickup-list-item' key={delivery.Code}>
                                    <a
                                        key={delivery.Code}
                                        data-value={delivery.Code}
                                        className='ms-store-select__location-line-pickup-list-link'
                                        tabIndex={0}
                                        aria-label={delivery.Description}
                                        onClick={this._onSelect}
                                        role='menuitem'
                                    >
                                        <span className='ms-store-select__location-line-pickup-list-item__text'>
                                            {delivery.Description}
                                        </span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                ) : null}
            </div>
        );
    }

    private _rendeDeliveryOptions(): void {
        const expandSiteOptionsState = this.state.expandSiteOptions;
        this.setState({
            expandSiteOptions: !expandSiteOptionsState
        });
    }

    private readonly _onSelect = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): Promise<void> => {
        e.preventDefault();
        const deliveryCode = e.currentTarget.getAttribute('data-value');
        if (deliveryCode && deliveryCode.length > 0) {
            await this.props.onChange(deliveryCode);
        }
    };
}
